module.exports = __webpack_public_path__ + "static/media/logo.819bc86e.svg";